import { AxiosRequestConfig } from "axios";

export const getVisits = (): AxiosRequestConfig => {
  return {
    url: "/claimants/visits/",
    method: "GET",
  };
};
